import styled, { css } from 'styled-components';

const lookLikeLink = (props) => props.onClick &&
    css `
    &:hover {
      cursor: pointer;
      text-decoration-line: underline;
      text-decoration-color: ${props => props.theme.colors.content.primary};
    }
  `;
const StyledCardHeader = styled.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 40px 32px 16px;
  tabindex: 0;

  svg {
    flex-shrink: 0;
  }

  ${props => props.theme.media.tabletPortraitDown} {
    padding: 40px 24px 16px;
  }

  ${lookLikeLink}
`;

export { StyledCardHeader };
